import PropTypes from 'prop-types';

import IFHolidayMustHavesActive from './IFHolidayMustHavesActive';
import IFHolidayMustHavesInactive from './IFHolidayMustHavesInactive';

function IFHolidayMustHaves({ className, isActive, width }) {
    return isActive ? (
        <IFHolidayMustHavesActive className={className} width={width} />
    ) : (
        <IFHolidayMustHavesInactive className={className} width={width} />
    );
}

export default IFHolidayMustHaves;

IFHolidayMustHaves.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    width: PropTypes.number,
};

IFHolidayMustHaves.defaultProps = {
    className: '',
    isActive: true,
    width: 24,
};
